var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LegendBar"},_vm._l((_vm.legend),function(l){return _c('LegendTag',{key:l.label,staticClass:"LegendBar__tag",attrs:{"name":l.name,"color":l.color}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }